import { useTranslation } from 'react-i18next';
import Progress from '../../../components/Progress/Progress';
import { formatDate } from '../../../core/helpers';

export default function OngoingFilingTab() {
  const { t } = useTranslation();
  return (
    <div>
      <div className='row row-cols-4 mb-3'>
        <div className='col'>
          <div className='Text--gray'>{t('Deadline')}</div>
          {formatDate(new Date(2020, 3, 25), 'dd MMMM yyyy')}
        </div>
        <div className='col'>
          <div className='Text--gray'>{t('Reporting period')}</div>
          {formatDate(new Date(2020, 2, 25), 'MMMM yyyy')}
        </div>
        <div className='col'>
          <div className='Text--gray'>{t('VAT to pay')}</div>
          calculating
        </div>
      </div>
      <Progress
        max={1}
        value={0}
        className='Progress--SellerCountryDetails'
        labelStart={t('Progress')}
        labelEnd={t('Scheduled')}
      />
    </div>
  );
}
